// UUID estavel por browser, persistido em localStorage (sobrevive a reload).
// Backend usa pra correlacionar sessoes em audit_log e em trusted devices 2FA.
// Header enviado em toda request: X-Device-Fingerprint.

const DEVICE_KEY = 'just-frotas:device_fingerprint';

export function getDeviceFingerprint(): string | null {
  try {
    let fp = window.localStorage.getItem(DEVICE_KEY);
    if (!fp) {
      fp =
        typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      window.localStorage.setItem(DEVICE_KEY, fp);
    }
    return fp;
  } catch {
    return null;
  }
}
